module.exports = __webpack_public_path__ + "img/Cutting-edge-digital-tools.b160f21b.svg";